import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import MarqueeRibbon from "../components/MarqueeRibbon";
import AboutSection from "../components/AboutSection";
import PracticeAreas from "../components/PracticeAreas";
import ApproachSection from "../components/ApproachSection";
import Testimonials from "../components/Testimonials";
import ContactSection from "../components/ContactSection";
import LocationSection from "../components/LocationSection";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#f7f3ea]">
      <Navbar />
      <HeroSection />
      <MarqueeRibbon />
      <AboutSection />
      <PracticeAreas />
      <ApproachSection />
      <Testimonials />
      <ContactSection />
      <LocationSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
